<template>
  <div class="wad4-button-icon">
    <slot/>
  </div>
</template>

<style lang="scss">
  .wad4-button-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 2.75rem;
    height: 2.75rem;
    color: $wad4-c-foreground-fg-tertiary;
    cursor: pointer;

    &:hover {
      background-color: $wad4-c-background-bg-brand-primary;
      color: $wad4-c-foreground-fg-primary;
    }

    &:active {
      background-color: $wad4-c-background-bg-brand-secondary;
      color: $wad4-c-foreground-fg-brand-solid
    }
  }

</style>
